<template>
  <v-container class="mt-12 pt-8" style="background: #fafafa;">
    <!-- Filters -->
    <v-row>
      <v-col cols="12" md="3">
        <v-autocomplete v-model="filters.account_ids" :items="accounts" item-value="id" :item-text="formatAccountOption"
          label="Accounts" multiple dense outlined chips clearable solo :search-input.sync="searchAccount"
          :loading="loading" :disabled="loading" />
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field v-model="filters.uuid" label="UUID" outlined dense :loading="loading" :disabled="loading" />
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field v-model="filters.date" type="date" label="Date" outlined dense :loading="loading"
          :disabled="loading" />
      </v-col>

      <v-col cols="12" md="3">
        <v-autocomplete v-model="filters.statuses" :items="statuses" label="Statuses" multiple dense outlined chips
          clearable :loading="loading" :disabled="loading" />
      </v-col>

      <v-col cols="12" md="6" class="d-flex align-center">
        <v-btn color="secondary" class="mx-2" :loading="loading" @click="searchLeadUpdates">
          Search
          <v-icon right>mdi-magnify</v-icon>
        </v-btn>
        <v-btn color="info" class="mx-2" :loading="loading" @click="resetFilters">
          Reset
          <v-icon right>mdi-refresh</v-icon>
        </v-btn>
        <v-btn color="primary" class="mx-2" :loading="loading" @click="exportLeadUpdates">
          Export
          <v-icon right>mdi-download</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-row v-if="leadUpdates.length > 0" class="mt-6">
      <v-col cols="12">
        <v-simple-table>
          <thead>
            <tr>
              <th>#</th>
              <th>UUID</th>
              <th>Status</th>
              <th>Account ID</th>
              <th>Documnet Number</th>

              <th>Date</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in leadUpdates" :key="index">
              <td>{{ getSerialNumber(index) }}</td>
              <td>{{ item.uuid }}</td>
              <td>{{ item.content }}</td>
              <td>{{ item.account_id }}</td>
              <td>{{ item.document_number }}</td>
              <td>{{ formatDate(item.created_at) }}</td>
              <td>{{ formatTime(item.created_at) }}</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="d-flex justify-center mt-5">
          <v-pagination v-model="currentPage" :length="lastPage" total-visible="7" color="secondary" @input="changePage"
            :disabled="loading"></v-pagination>
        </div>
      </v-col>
    </v-row>

    <v-row v-else-if="!loading">
      <v-col cols="12" class="text-center">
        <v-alert type="info" border="left" colored-border>
          No matching records found.
        </v-alert>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" class="text-center">
        <v-skeleton-loader type="table"></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import axios from 'axios';

export default {
  data() {
    return {
      loading: false,
      accounts: [],
      statuses: [],
      leadUpdates: [],
      filters: {
        account_ids: [],
        uuid: '',
        date: '',
        statuses: []
      },
      searchAccount: '',
      currentPage: 1,
      lastPage: 1,
      paginationData: {
        total: 0,
        per_page: 10,
        from: 0,
        to: 0
      }
    };
  },
  methods: {
    exportLeadUpdates() {
      const params = new URLSearchParams();
      if (this.filters.uuid) params.append('uuid', this.filters.uuid);
      if (this.filters.date) params.append('date', this.filters.date);
      if (this.filters.account_ids) {
        this.filters.account_ids.forEach(id => params.append('account_ids[]', id));
      }
      if (this.filters.statuses) {
        this.filters.statuses.forEach(status => params.append('statuses[]', status));
      }

      const fullUrl = `https://yervip.com/api/v1/admin/lead-updates/export?${params.toString()}`;

      window.open(fullUrl, '_blank');
    },


    formatAccountOption(account) {
      if (!account) return '';
      return `${account.id}`;
    },

    async fetchInitialData() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('getResource', {
          resource: '/list-accounts-and-statuses'
        });
        if (response) {
          this.accounts = response.accounts || [];
          this.statuses = response.statuses || [];
        }
      } catch (error) {
        this.showError('Error fetching accounts and statuses');
      } finally {
        this.loading = false;
      }
    },

    async searchLeadUpdates() {
      this.currentPage = 1;
      await this.fetchLeadUpdates();
    },

    async fetchLeadUpdates() {
      this.loading = true;
      try {
        const queryParams = new URLSearchParams();

        if (this.filters.account_ids.length > 0) {
          this.filters.account_ids.forEach(id => queryParams.append('account_ids[]', id));
        }

        if (this.filters.uuid) {
          queryParams.append('uuid', this.filters.uuid);
        }

        if (this.filters.date) {
          queryParams.append('date', this.filters.date);
        }

        if (this.filters.statuses.length > 0) {
          this.filters.statuses.forEach(status => queryParams.append('statuses[]', status));
        }

        queryParams.append('page', this.currentPage);

        const response = await this.$store.dispatch('getResource', {
          resource: `/lead-updates-search?${queryParams.toString()}`
        });

        if (response) {
          this.leadUpdates = response.data || [];

          this.paginationData = {
            total: response.total || 0,
            per_page: response.per_page || 10,
            from: response.from || 0,
            to: response.to || 0
          };

          this.lastPage = Math.ceil(this.paginationData.total / this.paginationData.per_page);
        }
      } catch (error) {
        console.error('Error fetching lead updates:', error);
        this.leadUpdates = [];
        this.lastPage = 1;
      } finally {
        this.loading = false;
      }
    },



    async changePage(page) {
      this.currentPage = page;
      await this.fetchLeadUpdates();
    },

    resetFilters() {
      this.filters = {
        account_ids: [],
        uuid: '',
        date: '',
        statuses: []
      };
      this.leadUpdates = [];
      this.currentPage = 1;
      this.lastPage = 1;
    },



    getSerialNumber(index) {
      return ((this.currentPage - 1) * this.paginationData.per_page) + index + 1;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    },

    formatTime(dateString) {
      const date = new Date(dateString);
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      return `${hours}:${minutes}:${seconds} ${ampm}`;
    },

    showError(message) {
      this.$store.dispatch('showToast', {
        type: 'error',
        message: message || 'Something went wrong!'
      });
    }
  },
  created() {
    this.fetchInitialData();
  }
};
</script>
